import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getOrders } from '../../services/orderService';
import { useOrderStore } from '../../store/useOrderStore.ts';

import OrderCard from '../../components/Fullfilment/OrderCard';
import OrderTabs from '../../components/Fullfilment/OrderTabs';
import SearchBox from '../../components/Fullfilment/SearchBox';
import Pagination from '../../components/Pagination';

import CustomerReviewModal from '../../components/Fullfilment/Rating/CustomerReviewModal';
import CustomerReviewViewModal from '../../components/Fullfilment/Rating/CustomerReviewViewModal';

const CustomerOrder = () => {

  const {
    activeTab,
    searchQuery,
    currentPage,
    pageSize,

    isReviewModalOpen,
    isReviewViewModalOpen,
    reviewEntity,
    reviewData,
    closeReviewModal
  } = useOrderStore();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['orders', activeTab, searchQuery, currentPage, pageSize],
    queryFn: () => getOrders(activeTab, searchQuery, currentPage, pageSize),
    staleTime: 1000 * 60 * 1,
    keepPreviousData: true,
    enabled: !!activeTab
  });

  useEffect(() => {
    console.log(pageSize);
  }, [activeTab, searchQuery]);

  let content;

  if (isLoading) {
    content = <SkeletonLoader count={5} />;
  } else if (error) {
    content = (
      <div className="text-center text-red-600 p-8">
        خطا در بارگذاری سفارشات: {error.message}
        <button
          onClick={() => refetch()}
          className="ml-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          تلاش مجدد
        </button>
      </div>
    );
  } else if (!data || data.results.length === 0) {
    content = (
      <div className="text-center text-gray-500 p-8">
        <p>هیچ سفارشی یافت نشد.</p>
        <p>لطفاً معیارهای جستجو یا تب را تغییر دهید.</p>
      </div>
    );
  } else {
    content = (
      <div className="space-y-4">
        {data.results.map((order) => (
          <OrderCard key={order.id} order={order} isAdmin={false} />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto px-4 py-8">

        <h1 className="text-3xl font-bold mb-6 text-gray-800">
          مدیریت سفارشات
        </h1>

        <OrderTabs />

        <SearchBox
          onSearch={(query) =>
            useOrderStore.getState().setSearchQuery(query)
          }
        />

        {content}

        {data && data.count > 0 && (
          <Pagination
            total={data.count}
            current={currentPage}
            pageSize={pageSize}
          />
        )}

      </div>

      {/* مودال ثبت یا ویرایش نظر */}
      <CustomerReviewModal
        open={isReviewModalOpen}
        entity={reviewEntity}
        review={reviewData}
        onClose={closeReviewModal}
      />

      {/* مودال مشاهده نظر */}
      <CustomerReviewViewModal
        open={isReviewViewModalOpen}
        onClose={closeReviewModal}
        entity={reviewEntity}
        reviewData={reviewData}
      />
    </>
  );
};


const SkeletonLoader = ({ count = 1 }) => (
  <div className="animate-pulse space-y-4 p-4 bg-white rounded-lg shadow">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="flex items-center space-x-4">
        <div className="w-16 h-16 bg-gray-300 rounded-full"></div>
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          <div className="h-3 bg-gray-300 rounded w-1/2"></div>
          <div className="h-4 bg-gray-300 rounded w-1/4 self-end"></div>
        </div>
      </div>
    ))}
  </div>
);

export default CustomerOrder;
